// src/components/portfolio/add-asset/utils/icons/StockIcon.js
import React from 'react';

const StockIcon = ({ symbol, symbolInfo }) => {
  const getStockLogo = (symbol) => {
    // URL'yi kendi projenize göre ayarlayın
    return `/images/stocks/${symbol.toLowerCase()}.png`;
  };

  return (
    <div className="w-8 h-8 rounded-full flex items-center justify-center bg-gray-100 dark:bg-gray-700">
      <img
        src={getStockLogo(symbol)}
        alt={symbol}
        className="w-6 h-6"
        onError={(e) => {
          e.target.onerror = null;
          e.target.style.display = 'none';
          e.target.parentElement.innerHTML = `<span class="text-sm font-medium">${symbol.slice(0, 2)}</span>`;
        }}
      />
    </div>
  );
};

export default StockIcon;